var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThriller = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Fantasy-Medieval-Assassins-Knife-Poison--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Fantasy Medieval Assassins Knife Poison Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.2 2.42A2.05 2.05 0 1 0 0.52 3.53a2.14 2.14 0 0 0 1.31 0.78l2.46 4.15L7.55 6Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.86 12.59a2.39 2.39 0 0 1 -2.71 -3.42L9.36 7.73 11 6.48a1.71 1.71 0 0 0 0.31 -2.4 0.75 0.75 0 0 0 -1.05 -0.14 0.76 0.76 0 0 0 -0.25 0.35 0.74 0.74 0 0 0 0.11 0.7 0.21 0.21 0 0 1 0 0.3l-6.93 5.27a1.68 1.68 0 0 0 -0.58 0.82A1.71 1.71 0 0 0 2.87 13a0.74 0.74 0 0 0 0.6 0.3 0.69 0.69 0 0 0 0.45 -0.16 0.74 0.74 0 0 0 0.14 -1 0.22 0.22 0 0 1 0 -0.3L6 10.28l4 5.24a9.81 9.81 0 0 0 3.19 2.68l4.08 2.13c0.16 -0.19 0.32 -0.36 0.49 -0.53Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.54 12.33c1 -1.1 3.18 -4.13 0.22 -5.39a1.53 1.53 0 0 0 -0.59 -0.13 2.08 2.08 0 0 0 -2.08 2.08 6.24 6.24 0 0 0 1.7 3.44 0.49 0.49 0 0 0 0.75 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.76 5.3A3.31 3.31 0 0 0 16 3.82a1.2 1.2 0 0 0 -0.81 -1.49 1.19 1.19 0 0 0 -1.49 0.81 3.28 3.28 0 0 0 0.3 1.94 0.5 0.5 0 0 0 0.76 0.22Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.23 17.2a2.09 2.09 0 0 0 -2.49 1.56 1.57 1.57 0 0 0 0 0.61c0.56 3.17 4 1.67 5.3 1a0.49 0.49 0 0 0 0.17 -0.73 6.27 6.27 0 0 0 -2.98 -2.44Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.94 18.27a1 1 0 0 0 -1.05 -0.95 8.36 8.36 0 0 0 -5.1 2.48c-0.17 0.17 -0.33 0.34 -0.49 0.53a7.19 7.19 0 0 0 -1.36 2.35 1 1 0 0 0 0.64 1.32 1.12 1.12 0 0 0 0.31 0.05 1 1 0 0 0 0.95 -0.69 6.5 6.5 0 0 1 5.15 -4 1 1 0 0 0 0.95 -1.09Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThriller);
export default ForwardRef;